<template>
    <div>
        <div class="order-tmp-caption" style="font-size: 15px;color: #1a1a1a;font-weight: 600;text-align: center;padding: 15px 0;"><span>{{devcMaintVoucher.title}}</span></div>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size: 12px;" v-for="comnItem in devcMaintVoucher.comnItemList">
            <tbody class="body">
            <tr class="row" v-if="comnItem.dtType != 8 && comnItem.dtType != 3">
                <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="">{{comnItem.label}}：{{comnItem.value}}</div>
                </td>
            </tr>
            <tr class="row" v-if="comnItem.dtType == 8">
                <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="">{{comnItem.label}}：{{comnItem.value ? '是' : '否'}}</div>
                </td>
            </tr>
            <tr class="row" v-if="comnItem.dtType == 3">
                <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="">{{comnItem.label}}：{{new Date(comnItem.value).format("yyyy年MM月dd日")}}</div>
                </td>
            </tr>
            </tbody>
        </table>
        <template v-if="groupFlag">
            <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size: 12px;">
                <thead class="head">
                <tr class="row">
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;">
                        <div>序号</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 120;width: 60px;">
                        <div>分组</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                        <div>维护保养项目（内容）</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                        <div>维护保养基本要求</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>评分标准</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>满分</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>得分</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;">
                        <div>需拍照</div>
                    </th>
                    <!--<th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">-->
                    <!--<div>图片</div>-->
                    <!--</th>-->
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                        <div>结果</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                        <div>结果说明</div>
                    </th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="(checkItem, index) in devcMaintVoucher.checkItemList">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{index + 1}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.group}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.content}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.demand}}</div>
                    </td>

                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>{{checkItem.scoreStd || ''}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>{{checkItem.fullScore || ''}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>{{checkItem.evalScore || ''}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.snapshotRequired ? '是' : '否'}}</div>
                    </td>
                    <!--<td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">-->
                    <!--<div v-if="checkItem.imgList != null && checkItem.imgList.length > 0">-->
                    <!--<img style="width: 120px;height: 120px;" :src="imgFile.fileBrowseUrl" v-for="imgFile in checkItem.imgList"/>-->
                    <!--</div>-->
                    <!--</td>-->
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.markChar == '✓' ? '√' : checkItem.markChar}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.remark}}</div>
                    </td>
                </tr>
                <tr class="row">
                    <td :colspan="devcMaintVoucher.examAndScoreFlag? 10:7" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="">说明：{{devcMaintVoucher.checkItemStateText}}</div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
        <template v-else-if="remarkFlag">
            <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size: 12px">
                <thead class="head">
                <tr class="row">
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;">
                        <div>序号</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                        <div>维护保养项目（内容）</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                        <div>维护保养基本要求</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 120;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>评分标准</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>满分</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>得分</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;">
                        <div>需拍照</div>
                    </th>
                    <!--<th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">-->
                    <!--<div>图片</div>-->
                    <!--</th>-->
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                        <div>结果</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                        <div>结果说明</div>
                    </th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="(checkItem, index) in devcMaintVoucher.checkItemList">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{index + 1}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.content}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.demand}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>{{checkItem.scoreStd || ''}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>{{checkItem.fullScore || ''}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>{{checkItem.evalScore || ''}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.snapshotRequired ? '是' : '否'}}</div>
                    </td>
                    <!--<td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">-->
                    <!--<div v-if="checkItem.imgList != null && checkItem.imgList.length > 0">-->
                    <!--<img style="width: 120px;height: 120px;" :src="imgFile.fileBrowseUrl" v-for="imgFile in checkItem.imgList"/>-->
                    <!--</div>-->
                    <!--</td>-->
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.markChar == '✓' ? '√' : checkItem.markChar}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.remark}}</div>
                    </td>
                </tr>
                <tr class="row">
                    <td :colspan="devcMaintVoucher.examAndScoreFlag? 9:7" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="">说明：{{devcMaintVoucher.checkItemStateText}}</div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
        <template v-else>
            <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size: 12px">
                <thead class="head">
                <tr class="row">
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;">
                        <div>序号</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                        <div>维护保养项目（内容）</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                        <div>维护保养基本要求</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 120;">
                        <div>维护保养情况</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>评分标准</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>满分</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>得分</div>
                    </th>
                    <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;">
                        <div>需拍照</div>
                    </th>
                    <!--<th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600; ">-->
                    <!--<div>图片</div>-->
                    <!--</th>-->
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="(checkItem, index) in devcMaintVoucher.checkItemList">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{index + 1}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.content}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.demand}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.markChar == '✓' ? '√' : checkItem.markChar}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>{{checkItem.scoreStd || ''}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>{{checkItem.fullScore || ''}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" v-if="devcMaintVoucher.examAndScoreFlag">
                        <div>{{checkItem.evalScore || 0}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{checkItem.snapshotRequired ? '是' : '否'}}</div>
                    </td>
                    <!--<td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">-->
                    <!--<div v-if="checkItem.imgList != null && checkItem.imgList.length > 0">-->
                    <!--<img style="width: 120px;height: 120px;" :src="imgFile.fileBrowseUrl" v-for="imgFile in checkItem.imgList"/>-->
                    <!--</div>-->
                    <!--</td>-->
                </tr>
                <tr class="row">
                    <td :colspan="devcMaintVoucher.examAndScoreFlag? 8:5" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="">说明：{{devcMaintVoucher.checkItemStateText}}</div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>

        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size: 12px">
            <thead class="head">
            <tr class="row">
                <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 60; width: 60px;">
                    <div>序号</div>
                </th>
                <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600; ">
                    <div>图片</div>
                </th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="(checkItem, index) in devcMaintVoucher.checkItemList">
                <template v-if="checkItem.imgList != null && checkItem.imgList.length > 0">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div>{{index + 1}}</div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <img style="width: 120px;height: 120px;" :src="imgFile.fileBrowseUrl" v-for="imgFile in checkItem.imgList"/>
                    </td>
                </template>
            </tr>
            </tbody>
        </table>

        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size: 12px;">
            <tbody class="body">
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;border-bottom:0px;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item clearfix">
                        <div class="label" style="width: 160px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>{{devcMaintVoucher.svcCmntLabel}}</span>
                        </div>
                        <div class="value" style="float: left; width: calc(100% - 160px); width: -webkit-calc(100% - 160px);white-space: normal; word-break: break-all;">
                            <span>{{devcMaintVoucher.svcCmntValue}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;border-bottom:0px;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item clearfix">
                        <div class="label" style="width: 160px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>{{devcMaintVoucher.useCmntLabel}}</span>
                        </div>
                        <div class="value" style="float: left; width: calc(100% - 160px); width: -webkit-calc(100% - 160px);white-space: normal; word-break: break-all;">
                            <span>{{devcMaintVoucher.useCmntValue}}</span>
                        </div>
                    </div>
                    <!--<div class="sign-name" style="height: 160px;text-align: center;">-->
                    <!--<img v-if="devcMaintVoucher.sigRequired" style="height: 90px; width: 100px;" :src=" devcMaintVoucher.useSigImgUrl"/>-->
                    <!--<span v-else>{{devcMaintVoucher.useSigImgUuid}}</span>-->
                    <!--</div>-->
                    <!--<div class="info-item clearfix">-->
                    <!--<div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">-->
                    <!--<span>{{devcMaintVoucher.useDateLabel}}</span>-->
                    <!--</div>-->
                    <!--<div class="value align-right" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;" v-if="devcMaintVoucher.useDateValue != null">-->
                    <!--<span>{{new Date(devcMaintVoucher.useDateValue).format("yyyy年MM月dd日")}}</span>-->
                    <!--</div>-->
                    <!--</div>-->
                </td>
            </tr>
            <tr>
                <td style="border: 1px solid #1a1a1a;border-top:0px;vertical-align: middle;padding: 10px 4px;">
                    <div class="sign-name" style="height: 160px;text-align: center;">
                        <img v-if="devcMaintVoucher.sigRequired" style="height: 100px;" :src="devcMaintVoucher.svcSigImgUrl"/>
                        <span v-else>{{devcMaintVoucher.svcSigImgUuid}}</span>
                    </div>
                    <div class="info-item clearfix">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>{{devcMaintVoucher.svcDateLabel}}</span>
                        </div>
                        <div class="value align-right" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;" v-if="devcMaintVoucher.svcDateValue != null">
                            <span>{{new Date(devcMaintVoucher.svcDateValue).format("yyyy年MM月dd日")}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;border-top:0px;vertical-align: middle;padding: 10px 4px;">
                    <div class="sign-name" style="height: 160px;text-align: center;">
                        <img v-if="devcMaintVoucher.sigRequired" style="height: 100px;" :src="devcMaintVoucher.useSigImgUrl"/>
                        <span v-else>{{devcMaintVoucher.useSigImgUuid}}</span>
                    </div>
                    <div class="info-item clearfix">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>{{devcMaintVoucher.useDateLabel}}</span>
                        </div>
                        <div class="value align-right" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;" v-if="devcMaintVoucher.useDateValue != null">
                            <span>{{new Date(devcMaintVoucher.useDateValue).format("yyyy年MM月dd日")}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    //
    import servcDelivApi from '../../api/servcDeliv'
    //
    export default {
        name: 'swb-servc-work-devc-maint-voucher-list',
        desc: '工单补充项目',
        props: ["id"],
        data: function () {
            return {
                devcMaintVoucher: {},
                groupFlag: false,
                remarkFlag: false,
            }
        },
        created: function () {
            this.getDevcMaintVoucher();
        },
        methods: {
            getDevcMaintVoucher: function () {
                let self = this;
                let postData = {
                    refSrcId: self.id,
                    refSrcFlag: 1,
                    includeItems: true,
                }
                servcDelivApi.getDevcMaintVoucherById(postData, function (result) {
                    if (result.type == "info") {
                        let devcMaintVoucher = result.data;
                        let checkItemList = devcMaintVoucher.checkItemList;
                        if (checkItemList.length > 0) {
                            let group = checkItemList[0].group;
                            let groupFlag = false;
                            if (!Utils.isNoB(group)) {
                                groupFlag = true;
                            }
                            let remark = checkItemList[0].remark;
                            let remarkFlag = false;
                            if (!Utils.isNoB(remark)) {
                                remarkFlag = true;
                            }
                            if (groupFlag && remarkFlag) {
                                self.groupFlag = true;
                            } else if (remarkFlag) {
                                self.remarkFlag = true;
                            }
                        }
                        self.devcMaintVoucher = devcMaintVoucher;
                    }
                })
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/DevcMaintVoucherPdf.vue